import { ReactNode } from 'react';
import { Stack } from '../Stack';
import { ActionToolbarContainer } from './style';

interface ActionToolbarProps {
    leftSide?: ReactNode;
    rightSide?: ReactNode;
    disabled?: boolean;
}

export const ActionToolbar = ({ leftSide, rightSide, disabled }: ActionToolbarProps) => (
    <ActionToolbarContainer
        itemAlignment="center"
        distribution="space-between"
        $disabled={disabled}
        aria-disabled={disabled}
    >
        {leftSide || <div />}
        <Stack spacing="100">{rightSide}</Stack>
    </ActionToolbarContainer>
);
